import { OPPORTUNITY_TYPES } from '@/constants';
import { Discover } from '.';

/**
 * Returns the type key name for a given opportunity type value
 * Eg, given 1, returns "technology"
 */
export function getOpportunityTypeNameFromValue(value: Discover.OpportunityTypeValue): Discover.OpportunityTypeName {
  return getOpportunityTypeFromValue(value).name;
}

/**
 * Returns full details for a given opportunity type value
 */
export function getOpportunityTypeFromValue(value: Discover.OpportunityTypeValue): {
  name: Discover.OpportunityTypeName;
  details: Discover.OpportunityTypes[Discover.OpportunityTypeName];
} {
  const entries = Object.entries(OPPORTUNITY_TYPES) as Array<
    [Discover.OpportunityTypeName, Discover.OpportunityTypes[Discover.OpportunityTypeName]]
  >;

  const match = entries.find(([, details]) => details.discover?.id === value);
  if (!match) {
    throw new Error(`Unknown opportunity type value: ${value}`);
  }

  const [name, details] = match;
  return { name, details };
}
